import SnackbarContent from "@mui/material/SnackbarContent";
export default SnackbarContent;
export * from "@mui/material/SnackbarContent";